<template>
    <div class="delivery-timeframe-express">
        <div class="content">
            <LabelExpressAvailable />

            {{ t('catalogue.express_chat_paragraph') }}
        </div>

        <div class="chat">
            <ThLink
                class="header-button contact-us-trigger"
                type="button"
                @click="openSpeakToExpertModal"
            >
                <span class="text">{{
                    t('catalogue.express_chat_button')
                }}</span>
            </ThLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useSpeakToExpertModal } from '@/composables/app/useSpeakToExpertModal'

import LabelExpressAvailable from '../layout/LabelExpressAvailable.vue'
import ThLink from '../ui/buttons/ThLink.vue'

const { t } = useI18n()

const { open: openSpeakToExpertModal } = useSpeakToExpertModal()
</script>

<style lang="scss" scoped src="./delivery-timeframe.scss"></style>

<style lang="scss" scoped>
.delivery-timeframe-express {
    display: flex;
    justify-content: space-between;
    background-color: $stone-2;

    .content {
        flex: 0 1 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        padding-right: 8px;
    }

    .chat {
        flex: 1 0 90px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .contact-us-trigger {
            display: block;
            padding-top: 8px;

            cursor: pointer;
            text-align: center;
            color: $slate;

            &::before {
                display: block;
                padding-bottom: 16px;
                text-indent: initial;
                font-family: $icon-font;
                font-size: 2.2rem;
                content: $icon-comment-rows;
            }

            .text {
                padding-top: 8px;

                font-family: $effra-font-stack;
                text-transform: uppercase;
                font-size: 0.75rem;
                letter-spacing: 0.05em;
            }
        }
    }
}
</style>
